<form [formGroup]="formGroup">
    <app-form-field [type]="fields.name.type" [options]="fields.name.options"></app-form-field>
	<app-form-field [type]="fields.json_data.type" [options]="fields.json_data.options"></app-form-field>
</form>

<div class="modal-footer">
    <button class="btn btn-success" (click)="submit()" [disabled]="!formGroup.valid"><i class="fa fa-save"></i> Guardar</button>
    <button class="btn btn-danger" (click)="modalRef.hide()"><i class="fa fa-times"></i> Cancelar</button>
</div>
